import { render } from "./SidebarItem.vue?vue&type=template&id=247d1d00&scoped=true"
import script from "./SidebarItem.vue?vue&type=script&lang=js"
export * from "./SidebarItem.vue?vue&type=script&lang=js"

import "./SidebarItem.vue?vue&type=style&index=0&id=247d1d00&scoped=true&lang=css"

import exportComponent from "D:\\Dev\\Projects\\Web\\era-old.proj\\era.alpha-23-24.local\\node_modules\\.pnpm\\vue-loader@16.8.3_@vue+compiler-sfc@3.3.8_vue@3.3.8_webpack@4.47.0\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-247d1d00"]])

export default __exports__